<template>
  <v-layout row wrap justify-center class="authentication" :style="siteStyles">
    <div v-if="loading && !getExtras && !sn" class="loader">
      <!-- <v-progress-linear height="4" :color="borderColor" :indeterminate="true"></v-progress-linear> -->
      <hollow-dots-spinner
        :animation-duration="1500"
        :dot-size="20"
        :dots-num="3"
        :color="borderColor"
      />
    </div>
    <div v-else-if="$route.name === 'account' || $route.name === 'documents'"></div>
    <div :class="'main-box'" v-else-if="!getExtras && !sn">
      <template v-if="$route.name === 'signin'">
        <sign-in ref="signInComp"></sign-in>
      </template>
      <template v-if="$route.name === 'resetpassword'">
        <forgot-password></forgot-password>
      </template>
      <template v-if="$route.name === 'forgotusername'">
        <forgot-username></forgot-username>
      </template>
      <template v-if="$route.name === 'signup'">
        <sign-up class="sign-up"></sign-up>
      </template>
      <div v-if="authError" class="customError" v-html="authError"></div>
    </div>
  </v-layout>
</template>

<script>
import { HollowDotsSpinner } from 'epic-spinners'
import { AmplifyEventBus } from "aws-amplify-vue";
import { Hub, Logger, Cache } from "aws-amplify";
import { mapState } from "vuex";
import { $unAuthUser, $authUser } from "@/plugins/axios";
import { getUser, getUserInfo } from "@/graphql/queries";
import { updateSignUpUser } from "@/graphql/mutations";
import { reject, Promise } from "q";
import SignUp from "@/components/SignUp.vue";
import SignIn from "@/components/SignIn.vue";
import ForgotPassword from "@/components/ForgotPassword.vue";
import ForgotUsername from "@/components/ForgotUsername.vue";
import countries from "aws-amplify-vue/src/assets/countries";
const alex = new Logger("Alexander_the_auth_watcher");
import Privacy from "@/components/Privacy.vue";
import {
  CognitoUserPool,
  CognitoUserAttribute,
  CognitoUser,
} from "amazon-cognito-identity-js";
export default {
  name: "authentication",
  components: {
    SignUp,
    Privacy,
    SignIn,
    ForgotPassword,
    ForgotUsername,
    HollowDotsSpinner
  },
  async created() {
    console.log('auth created')
    if (this.lastReview) return
    this.$root.$on("removeExtras", () => {
      this.getExtras = false;
    });

    let newPass = false;
    // changes state depending on authorization
    AmplifyEventBus.$on("authState", (info) => {
      console.log('eventbus')
      if (info === "signedIn" && this.confirmed) {
        this.$store.commit("user/setState", "signedIn");
      } else if (info === "requireNewPassword") {
        newPass = true;
        this.$store.commit("user/emptyUser");
        this.$store.commit("user/setState", "requireNewPassword");
        this.$store.commit(
          "user/setResetUser",
          this.$store.state.user.resetUser
        );
        this.$router.push("/resetpassword");
        // this.$store.commit("user/setResetUser", data.username);
      } else if (info === "signedIn") {
        return;
      } else {
        this.$store.commit("user/setState", info);
      }
      let message = "";
    });

    if (!newPass) {
      // sets up listener for events
      this.auth();
      // check the user
      await this.checkUser();
    }
  },
  data() {
    return {
      banner: false,
      alerusPhone: "833-325-3787",
      mersPhone: "800-767-6377",
      methodPlaceholder: "Text or Call?",
      phonePlaceholder: "Please select phone",
      country: "1",
      countries,
      redirect: false,
      rules: {
        required: (v) => !!v || "Required",
        min: (v) => v.length >= 15 || "Min 15 characters",
        upper: (v) => /[A-Z]/.test(v) || "Must include uppercase letter",
        lower: (v) => /[a-z]/.test(v) || "Must include lowercase letter",
        number: (v) => /[0-9]/.test(v) || "Must include number",
        email: (v) => /.+@.+/.test(v) || "Invalid email address",
      },
      product: "",
      passAttempts: 0,
      success: false,
      dialog: false,
      userResponse: false,
      snPhone: "",
      terms: "",
      snCode: "",
      snSubmit: false,
      snResend: false,
      snMethod: "text",
      phoneOptions: ["text", "call"],
      bb: false,
      productLabel: "Product Number",
      productMask: "",
      userLoggedIn: false,
      getExtras: false,
      error: "",
      extraInfo: {
        dob: "",
        ssn: "",
        acc_num: "",
        last_name: "",
        product: "",
        hireMonth: "",
        hireYear: "",
      },
      userAtt: "",
      signUpConfig: {
        signUpFields: [
          {
            label: "Password",
            key: "password",
            required: true,
            type: "password",
            displayOrder: 3,
            value: "",
          },
          {
            label: "Confirm Password",
            key: "password2",
            required: true,
            type: "password",
            displayOrder: 4,
            value: "",
          },
          {
            label: "Hide Birthday",
            key: "birthdate",
            required: true,
            type: "string",
            displayOrder: 6,
            value: "0000000000",
          },
          {
            label: "Birthdate",
            key: "custom:dateofbirth",
            type: "number",
            displayOrder: 5,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("user", [
      "user",
      "state",
      "confirmed",
      "box",
      "phones",
      "sn",
      "snAnswer",
      "snError",
      "loading",
      "password",
      "adminReset",
      "resetUser",
      "mersBranded",
      "snMfa",
      "awsMfa",
      "userDetails",
      "lastReview",
      "reviewMode",
      "mfa",
      "hub",
      "authError"
    ]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    borderColor() {
      return this.mersBranded ? "#E8E2D0" : "#40A8CB";
    },
    headerColor() {
      return this.mersBranded ? "#2F6C55" : "#0B2A4A";
    },
    anchorColor() {
      return this.mersBranded ? "#2F6C55" : "#297d97";
    },
    siteStyles() {
      return {
        '--app-button-color': this.appButtonColor,
        '--border-top': this.borderColor,
        '--header-color': this.headerColor,
        '--anchor-color': this.anchorColor
      }
    },
    loginFailMessage() {
      return `User registration failed. This can be due to:<br>
      1. We are unable to validate your information. Please double check your information and make sure it's valid.<br>
      2. You already have an existing account. From the login screen select Find Username or Forgot Password to access your account.<br>
      We're here to help. Contact our Client Service Center at ${this.mersBranded ? "800.767.6377" : "833.325.3787"} for assistance.
      `
    },
  },
  watch: {
    state() {
      this.$store.commit("user/setAuthError", "")
    },
    phones(val) {
      this.snPhone = val[0];
    },
  },
  methods: {
    getProduct() {
      this.extraInfo["acc_num"] = "";
      if (this.extraInfo.product === "banking") {
        this.productLabel = "Account Number";
        this.productMask = "###############";
      } else if (this.extraInfo.product === "retirement") {
        this.productLabel = "Hire Month and Year";
        this.productMask = "##/####";
      } else if (this.extraInfo.product === "card") {
        this.productLabel = "Last 6 Digits of Debit Card";
        this.productMask = "######";
      }
    },
    auth() {
      if (this.hub) return
      alex.onHubCapsule = async (capsule) => {
        console.log('auth')
        let error;
        if (this.adminReset) return;
        if (!capsule.payload.data) {
          error = "";
        } else error = capsule.payload.data.message;
        this.$store.commit("user/setAuthError", "")
        switch (capsule.payload.event) {
          case "signIn":
            console.log('check auth')
            let user = await this.$Amplify.Auth.currentAuthenticatedUser({
              bypassCache: true,
            });
            this.$store.commit("user/setLoading", true);
            this.$store.commit("user/setUser", user);
            this.clearLogins();

            let flags = {};
            if (user.attributes.hasOwnProperty("custom:userFlags")) {
              flags = JSON.parse(user.attributes["custom:userFlags"]);
            } else {
              flags = {
                isAdmin: false,
                OCEAccess: false,
                CFUAccess: false,
                isWexFLXAdmin: false
              };
            }

            let customSso = false
            if (user.attributes.hasOwnProperty("custom:defaultSso")) {
              customSso = true
            }

            // check user flags or route query for system property
            let system = this.checkSystem()
            system.query = this.$route

            if (
              user.attributes.hasOwnProperty("custom:alerus360id") ||
              flags.isAdmin ||
              flags.OCEAccess ||
              flags.CFUAccess ||
              flags.isWexFLXAdmin ||
              customSso
            ) {
              if (await this.$store.dispatch("user/checkBB", {
                signIn: true
              })) {
                if (
                  this.$router.currentRoute.name !== "account" &&
                  this.$router.currentRoute.name !== "documents"
                ) {
                  console.log('auth..')
                  await this.$store.dispatch("user/checkForAdminUser", system);
                } else this.$store.commit("user/setConfirmed");
              } else {
                // Secure Now check user
                this.$store.commit("user/setSN", true);
                console.log("checking user here 1");
              }
            } else {
              this.getExtras = true;
              this.populateExtras();
            }
            break;
          case "signUp":
            this.$store.commit("user/setAuthError", error)
            break;
          case "signOut":
            this.success = false;
            //alex.error("user signed out");
            break;
          case "signIn_failure":
            console.log(error)
            var registerDate = this.mersBranded ? "Incorrect Username or Password. If you have not registered since 4/7/2020, click Create myMERS Account." : "Incorrect Username or Password. If you have not registered, click Sign Up.";
            if (error === "User is not confirmed.") {
              this.$store.commit("user/setState", "confirmSignUp");
            } else if (error === "Password reset required for the user" || error === 'DefineAuthChallenge failed with error RESET_REQUIRED.') {
              this.$store.commit("user/setState", "forgotPassword");
              this.$router.push("/resetpassword");
            } else if (error === "User does not exist.") {
              this.$store.commit("user/setAuthError", registerDate)
            } else if (error === "Incorrect username or password.") {
              // create log for failed login attempt
              await this.$store.dispatch("user/createLog", {
                username: this.$refs.signInComp.options.username,
                log: "SignInFailed",
                app: "MyAlerus",
              });
              let message = await this.loginAttempts(
                this.$refs.signInComp.options.username
              );
              if (message) {
                this.$store.commit("user/setAuthError", message)
              } else {
                this.$store.commit("user/setAuthError", registerDate)
              }
            } else if (error === "Password attempts exceeded") {
              this.$store.commit("user/setAuthError", "Password attempts exceeded. Please wait before trying again.")
            } else if (error === "User is disabled.") {
              this.$store.commit("user/setAuthError", "Your account is locked. Please contact our support center.")
            } else {
              // alex.error("sign in failed");
              this.$store.commit("user/setAuthError", error)
            }
            if (this.$refs.signInComp) {
              this.$refs.signInComp.password = "";
            }
            break;
          case "signUp_failure":
            if (
              error ===
              "PreSignUp failed with error A user with the same email address exists."
            ) {
              this.$store.commit("user/setAuthError", "A user with the same email already exists.")
            } else if (
              error === "PreSignUp failed with error User exists in ODS."
            ) {
              this.$store.commit("user/setAuthError", "User already exists. Please sign in.")
            } else if (
              error === "PreSignUp failed with error User not found."
            ) {
              this.$store.commit("user/setAuthError", this.loginFailMessage)
            } else if (
              error === "PreSignUp failed with error please accept terms."
            ) {
              return;
            } else if (
              error === "PreSignUp failed with error User already exists."
            ) {
              this.$store.commit("user/setAuthError", "Username already exists, please create another.")
            } else if (error === "PreSignUp failed with error Access Denied.") {
              this.$store.commit("user/setAuthError", "Access denied. Please contact our support center.")
            }
            else if (
              error === "PreSignUp failed with error Unable to verify your account."
            ) {
              this.$store.commit("user/setAuthError", this.loginFailMessage)
            }
            else this.$store.commit("user/setAuthError", error)
            break;
          case "configured":
            //alex.error("the Auth module is configured");
            break;
        }
      };
      this.$store.dispatch("user/changeHub", alex)
    },
    async checkUser() {
      try {
        if (this.reviewMode) {
          this.checkProperty();
        }
        else {
          if (!this.user) {
            console.log('get currentAuthenticatedUser')
            let user = await this.$Amplify.Auth.currentAuthenticatedUser({
              bypassCache: true
            });
            this.$store.commit("user/setUser", user);
          }
          this.$store.commit("user/setLoading", true);
          this.checkProperty();
        }
      } catch (error) {
        this.$store.commit("user/setState", "signedOut");
        // this.$router.push("/");
      }
    },
    checkSystem(system) {
      if (this.$route.query.system) {
        let returnVal = { system: this.$route.query.system }
        if (this.$route.query.target) {
          returnVal.target = this.$route.query.target
        }
        if (this.$route.query.planId) {
          returnVal.planId = this.$route.query.planId
        }
        return returnVal
      }
      else if (!system) return {}
      else return { system }
    },
    async checkTerms() {
      this.dialog = true;
      let result = await new Promise((res, rej) => {
        this.$on("answer", (ans) => res(ans));
      });
      let ans;
      if (result) {
        this.terms = new Date().toISOString();
        ans = true;
      } else {
        ans = false;
      }
      this.dialog = false;
      return ans;
    },
    async loginAttempts(username) {
      let attempts = await this.$store.dispatch(
        "user/checkFailedAttempts",
        username
      );
      if (attempts === 4) {
        return "You've attempted to login 4 times. Your account will be locked if you are incorrect 1 more time.";
      } else if (attempts > 4) {
        return "We've locked your account. Please contact our support center.";
      } else return false;
    },
    clearLogins() {
      let att = localStorage.getItem("passAttempts");
      if (att == null) return;
      else localStorage.removeItem("passAttempts");
    },
    async checkProperty() {
      console.log('auth checkProperty')

      let flags = {};
      if (this.user.attributes.hasOwnProperty("custom:userFlags")) {
        flags = JSON.parse(this.user.attributes["custom:userFlags"]);
      } else {
        flags = {
          isAdmin: false,
          OCEAccess: false,
          CFUAccess: false,
          isWexFLXAdmin: false
        };
      }

      let customSso = false
      if (this.user.attributes.hasOwnProperty("custom:defaultSso")) {
        customSso = true
      }

      // check user flags or route query for system property
      let system = this.checkSystem()
      system.query = this.$route

      if (
        this.user.attributes.hasOwnProperty("custom:alerus360id") ||
        flags.isAdmin ||
        flags.OCEAccess ||
        flags.CFUAccess ||
        flags.isWexFLXAdmin ||
        customSso
      ) {
        if (await this.$store.dispatch("user/checkBB")) {
          // console.log("check 2 succeeded");
          if (
            this.$router.currentRoute.name !== "account" &&
            this.$router.currentRoute.name !== "documents"
          ) {
            await this.$store.dispatch("user/checkForAdminUser", system);
          } else this.$store.commit("user/setConfirmed");
        } else {
          // Secure Now check user
          this.$store.commit("user/setSN", true);
          console.log("checking user here 2 auth");
        }
      } else {
        this.getExtras = true;
        this.populateExtras();
      }
    },
    populateExtras() {
      if (this.user.attributes.hasOwnProperty("custom:dateofbirth")) {
        this.extraInfo.dob = this.user.attributes["custom:dateofbirth"];
      }
    },
    getAnswer(val) {
      this.$emit("answer", val);
      if (val) {
        this.userResponse = true;
      }
    },
    async snVerify() {
      if (!this.snCode) return;
      let result = await this.$store.dispatch("user/snValidate", this.snCode);
      this.snCode = "";
      this.snResend = false;
      this.$store.commit("user/setAuthError", "")
      if (result === "Failed challenge") {
        this.$store.commit("user/setAuthError", "Code incorrect. Please try again or click Resend Code")
      }
    },
    async checkUserDetails() {
      console.log('auth checkUserDetails')
      const { data } = await $unAuthUser.post(
        "/",
        {
          query: getUser,
          variables: {
            username: this.extraInfo.ssn,
          },
        },
        {
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
        }
      );
    },
    async sendDetails() {
      this.$store.commit("user/setAuthError", "")
      if (this.extraInfo.product === "retirement") {
        var month = this.extraInfo["acc_num"].slice(0, 2);
        var year = this.extraInfo["acc_num"].slice(2);
      } else if (this.extraInfo.product === "card") {
        var digits = this.extraInfo["acc_num"];
      }
      const { data } = await $authUser.post(
        "/confirmAccountDetails",
        {
          accountNumber:
            this.extraInfo.product === "banking" ? this.extraInfo.acc_num : "",
          ssn: this.extraInfo.ssn,
          accountType: this.extraInfo.product,
          dob: this.extraInfo.dob,
          lastName: this.extraInfo.last_name,
          hireMonth: month ? month : "",
          hireYear: year ? year : "",
          lastSixDigitsCard: digits ? digits : "",
        },
        {
          headers: {
            Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
        }
      );

      if (data.a360id && data.cif) {
        this.addUserProps(data);
      } else {
        this.$store.commit("user/setAuthError", "User not found. Please check your information.")
      }
    },
    checkInfo(info) {
      if (
        this.extraInfo.ssn === info.ssn &&
        this.extraInfo.dob === info.dateOfBirth &&
        this.extraInfo.acc_num === info.accNum
      )
        return true;
      else return false;
    },
    async refreshToken() {
      let cogPool = new CognitoUserPool({
        UserPoolId: process.env.VUE_APP_POOL_ID,
        ClientId: process.env.VUE_APP_POOL_CLIENT_ID,
      });

      let cogUser = new CognitoUser({
        Username: "user3",
        Pool: cogPool,
      });

      let cogSession = () => {
        return new Promise((res) => {
          cogUser.getSession((err, data) => {
            res(data);
          });
        });
      };
      let sess = await cogSession();
      let token = sess.getRefreshToken();
      let cogRefresh = () => {
        return new Promise((res) => {
          cogUser.refreshSession(token, (err, data) => {
            res(data);
          });
        });
      };
      let result = await cogRefresh();
      console.log(result);
    },
    async addUserProps(props) {
      console.log('addUserProps')
      let newAttributes = [
        {
          Name: "custom:alerus360id",
          Value: props.a360id,
        },
        {
          Name: "custom:cif",
          Value: props.cif,
        },
      ];

      const { data } = await $unAuthUser.post(
        "/",
        {
          query: updateSignUpUser,
          variables: {
            username: this.user.username,
            password: this.password,
            newAtts: newAttributes,
          },
        },
        {
          headers: {
            Authorization: this.user.signInUserSession.idToken.jwtToken,
          },
        }
      );
      let result = data.data.updateSignUpUser;
      if (result.a360idSuccess && result.cifSuccess) {
        console.log("user updated successfully");
        this.$store.commit("user/emptyPassword");
        this.$store.commit("user/setState", "signedIn");
        this.getExtras = false;
        await this.$Amplify.Auth.updateUserAttributes(this.user);
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_POOL_CLIENT_ID}.${this.user.username}.idToken`,
          result.idToken
        );
        localStorage.setItem(
          `CognitoIdentityServiceProvider.${process.env.VUE_APP_POOL_CLIENT_ID}.${this.user.username}.accessToken`,
          result.accessToken
        );
        await this.checkUser();
      } else {
        console.log("error updating user");
      }
    },
    async getSystem(system) {
      let { data: authSystem } = await $authUser.get(
        // `/getSystemLink?system=${system}`,
        `/getSystemLink`,
        {
          headers: {
            Authorization: `Bearer ${this.user.signInUserSession.idToken.jwtToken}`,
          },
        }
      );
      return `https://applanding.alerus.com/?auth=${authSystem}`;
    },
  }
};
</script>

<style lang="scss">
.dot {
  background-color: var(--border-top) !important;
}
.hollow-dots-spinner {
  margin: 0 auto;
}
.migrationError {
  color: #fd0000;
  font-size: 1.1rem;
}
form {
  width: 100%;
}
.migration {
  h2 {
    font-size: 1.25rem;
    font-weight: initial;
    margin-top: 0.5rem;
  }
  span {
    color: #40a7c7;
  }
}
.loader {
  width: 100%;
  .v-progress-linear {
    margin: 0;
  }
}
.authentication {
  margin: 0 auto;
  max-width: 70%;
  a {
    color: #0C2B4A;
  }
  button {
    // text-transform: capitalize;
    color: #fff;
    background-color: #0C2B4A;
    &:active {
      background-color: #0C2B4A;
    }
    &:focus {
      outline: none;
    }
  }
  .error {
    margin-top: 1.5rem;
    color: #fd0000;
  }
}
.mers {
  .authentication,
  .v-dialog {
    button {
      border-radius: 4px;
    }
    a {
      color: #33715a;
    }
    button {
      background-color: #33715a !important;
      &:active {
        background-color: #33715a !important;
      }
    }
  }
}
.error {
  display: none;
}
.form-submit {
  .v-btn__content {
    color: #fff;
  }
}
.extras {
  //background-color: #fff;
  width: 100%;
  margin: 0 auto;
  display: inline-block;
  padding: 2rem;
  border-radius: 2px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  span {
    color: #40a7c7;
  }
  .flex-ct {
    width: 100%;
  }
  h2 {
    font-weight: initial;
  }
  h3 {
    margin-top: 0;
    width: 100%;
    font-size: 1.25rem;
    font-weight: initial;
  }
  .items {
    width: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    // align-items: center;
    & > div {
      display: inline-flex;
      margin: 0.25rem 0;
      text-align: left;
      label {
        padding-right: 0.5rem;
        font-size: 1rem;
      }
    }
  }
  button.form-submit {
    margin-top: 1.5rem;
    font-size: 1.1rem;
    padding: 0.5rem 1.5rem;
    font-family: "the-serif";
    cursor: pointer;
  }
}
.sign-up {
  .Section__sectionBody___ihqqd {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    & > div {
      width: 49%;
    }
    & > div:last-child {
      // display: none;
    }
  }
}
.success {
  background-color: #fff;
  display: inline-block;
  padding: 2rem;
  border-radius: 2px;
  h3 {
    margin-top: 0;
  }
}
.check-user {
  color: #fff;
  padding: 1rem;
}
.main-box {
  border-top: 4px solid;
  border-top-color: var(--border-top);
  background-color: #fff;
  width: 100%;
  padding: 5rem 10rem;
  // box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
  & > div:first-child {
    margin-bottom: 0;
    box-shadow: none;
  }
  .Section__sectionHeader___2djyg, .main-blue {
    font-size: 1.75rem;
    font-weight: 600;
    color: var(--header-color);
    margin-bottom: 0;
  }
  .Form__formSection___1PPvW {
    min-width: 100%;
    padding: 0;
  }
  .Input__inputLabel___3VF0S, .Input__inputLabel___nQolz {
    color: #212529;
    font-weight: bold;
  }
  .Form__formField___38Ikl {
    .Anchor__a___1_Iz8 {
      color: var(--anchor-color);
      font-size: 1rem;
    }
  }
}
.noAuthBox {
  width: 100%;
}
.customError {
  color: red;
  position: relative;
  display: inline-block;
}
</style>